module.exports = __webpack_public_path__ + "img/mutter_md.dcae938e.png";